import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { sessionExpireMessage, toastError, toastSuccess, tokenInavlidMessage } from '../../../utils/constants'
import Header from '../../../common_components/Header';
import Loader from '../../../utils/Loader';
import { get_promoCode_details_action, insert_promoCode_action, update_promoCode_action } from '../../../actions/adminAction/promoCode_action';

class promoCodeDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            navType: '',
            PromoCodeID: '',
            Count: '',
            Discountpercent: '',
            ExpiryDate: '',
            CouponCode: '',
            // ERROR
            CountErr: '',
            DiscountpercentErr: '',
            ExpiryDateErr: '',

        }
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const navType = this.props.location?.state?.navType
            const PromoCodeID = this.props.location?.state?.PromoCodeID
            this.setState({ navType: navType, PromoCodeID: PromoCodeID }, () => {
                if (PromoCodeID) {
                    this.getPromoCodeDetails(PromoCodeID)
                }
            })
        }
    }
    getPromoCodeDetails(PromoCodeID) {
        this.setState({ isLoading: true })
        this.props.get_promoCode_details_action(PromoCodeID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    const promoData = data.data?.[0];
                    this.setState({
                        PromoCodeID: promoData.PromoCodeID,
                        CouponCode: promoData.Code,
                        Discountpercent: promoData.DiscountPercent,
                        ExpiryDate: promoData.ExpiryDate,
                    })

                    this.setState({ isLoading: false })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data?.data?.ErrorMsg);
                }
            })
    }

    insertPromoCode() {
        const { Count, Discountpercent, ExpiryDate } = this.state
        this.inputValidation().then(res => {
            if (!res) {
                this.setState({ isLoading: true })
                this.props
                    .insert_promoCode_action(Count, Discountpercent, ExpiryDate)
                    .then((data) => {
                        if (data.error != 1) {
                            if (data.data.ErrorMsg == null) {
                                this.setState({ isLoading: false }, () => toastSuccess('Submitted Successfully'))
                                setTimeout(() => {
                                    this.props.navigate('/promocode_list')
                                }, 500);
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.data.ErrorMsg);
                            }
                        } else {
                            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                //after session expire.....................
                                sessionStorage.clear();
                                this.props.navigate("/");
                                setTimeout(() => {
                                    toastError(data.msg);
                                }, 2000);
                            } else {
                                toastError(data.data);
                            }
                            this.setState({ isLoading: false })
                            toastError(data.msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please enter mandatory fields")
            }
        })
    }
    updatePromoCode() {
        const { PromoCodeID, Discountpercent, ExpiryDate } = this.state
        this.inputValidation().then(res => {
            if (!res) {
                this.setState({ isLoading: true })
                this.props
                    .update_promoCode_action(PromoCodeID, Discountpercent, ExpiryDate)
                    .then((data) => {
                        if (data.error != 1) {
                            if (data.data.ErrorMsg == null) {
                                this.setState({ isLoading: false }, () => toastSuccess('Updated Successfully'))
                                setTimeout(() => {
                                    this.props.navigate('/promocode_list')
                                }, 500);
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.data.ErrorMsg);
                            }
                        } else {
                            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                //after session expire.....................
                                sessionStorage.clear();
                                this.props.navigate("/");
                                setTimeout(() => {
                                    toastError(data.msg);
                                }, 2000);
                            } else {
                                toastError(data.data);
                            }
                            this.setState({ isLoading: false })
                            toastError(data.msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please enter mandatory fields")
            }
        })
    }

    inputValidation() {
        const { PromoCodeID, Count, CountErr, Discountpercent, DiscountpercentErr, ExpiryDate, ExpiryDateErr } = this.state
        var Err = false
        return new Promise((resolve) => {
            if (!PromoCodeID) {
                if (Count == '' || Count == null) {
                    Err = true
                    this.setState({ CountErr: 'Please enter Count' })
                }
            }
            if (Discountpercent == '' || Discountpercent == null) {
                Err = true
                this.setState({ DiscountpercentErr: 'Please enter Discount' })
            }
            if (ExpiryDate == '' || ExpiryDate == null) {
                Err = true
                this.setState({ ExpiryDateErr: 'Please enter Expiry Date' })
            }

            resolve(Err)
        })
    }


    navigateBackPromoList() {
        this.props.navigate('/promocode_list')
    }
    render() {
        const { isLoading, PromoCodeID, navType, Count, CountErr, CouponCode, ExpiryDate, ExpiryDateErr, Discountpercent, DiscountpercentErr } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <h6 className='pt-2'>Promo Code Details</h6>
                        <div class="row mt-15">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="custom_tabs" id="mytabs">
                                            <div class="tab-content">
                                                <div class="tab-pane active" id="Company_Profile_tab" role="tabpanel" aria-labelledby="Company_Profile_tab" tabindex="0">
                                                    <fieldset>
                                                        <legend className='mb-0 pb-0'>Coupon Details</legend>
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="row mb-3">
                                                                    {navType == 3 ? <>
                                                                        <div class="col-md-3">
                                                                            <div class="form-group">
                                                                                <label>No of Coupons<span className="red-star text-danger">*</span></label>
                                                                                <input type="text" class="form-control" placeholder="Enter No Of Coupons" value={Count} onChange={(e) => this.setState({ Count: e.target.value, CountErr: '' })} maxLength={1000} />
                                                                                {<span className='text-danger text-start text-left d-block  ml-2'>{CountErr}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </> : <>
                                                                        <div class="col-md-3">
                                                                            <div class="form-group">
                                                                                <label>Coupon Code<span className="red-star text-danger">*</span></label>
                                                                                <input type="text" disabled class="form-control" placeholder="Coupon Code" value={CouponCode} />
                                                                            </div>
                                                                        </div>
                                                                    </>}
                                                                    <div class="col-md-3">
                                                                        <div class="form-group">
                                                                            <label>% Discount<span className="red-star text-danger">*</span></label>
                                                                            <input type="number" disabled={navType == 1} class="form-control" placeholder="Enter percent discount" value={Discountpercent} onChange={(e) => this.setState({ Discountpercent: e.target.value, DiscountpercentErr: '' })} />
                                                                            {<span className='text-danger text-start text-left d-block  ml-2'>{DiscountpercentErr}</span>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <div className="form-group">
                                                                            <label>Expiry Date<span className="red-star text-danger">*</span></label>
                                                                            <input
                                                                                type="date"
                                                                                disabled={navType === 1}
                                                                                className="form-control"
                                                                                placeholder="Expiry Date"
                                                                                value={ExpiryDate ? ExpiryDate.substring(0, 10) : ''}
                                                                                onChange={(e) => this.setState({ ExpiryDate: e.target.value, ExpiryDateErr: '' })}
                                                                            />
                                                                        </div>
                                                                        {<span className='text-danger text-start text-left d-block ml-2'>{ExpiryDateErr}</span>}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                    <div class="row">
                                                        <div class="col-md-12 text-right">
                                                            <button class="btn btn-primary next_btn mx-2"
                                                                onClick={() => this.navigateBackPromoList()}
                                                            >
                                                                Back
                                                            </button>
                                                            {PromoCodeID ? <>
                                                                <button class="btn btn-primary next_btn"
                                                                    onClick={() => this.updatePromoCode()}
                                                                >
                                                                    Update
                                                                </button>
                                                            </> : <>
                                                                <button class="btn btn-primary next_btn"
                                                                    onClick={() => this.insertPromoCode()}
                                                                >
                                                                    Submit
                                                                </button>
                                                            </>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </section >
            </>
        )
    }
}

export default withRouter(connect(null, { get_promoCode_details_action, insert_promoCode_action, update_promoCode_action, })(promoCodeDetail));
